'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RSS = require('./RSS');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RSS).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/RSS/index.js
// module id = 1270
// module chunks = 1